import { createGlobalStore } from "@wss/store";

interface CartQuantityState {
  quantity: number;
  addToCartQuantity: (addQty: number) => void;
  setCartQuantity: (qty: number) => void;
}

const cartQuantityStore = createGlobalStore<CartQuantityState>((set) => ({
  quantity: 0,
  addToCartQuantity: (addQty) =>
    set((state) => ({
      quantity: state.quantity + addQty,
    })),
  setCartQuantity: (qty) => set({ quantity: qty }),
}));

export default cartQuantityStore;
